export default __webpack_public_path__ + "static/media/bannerImg5.266d30d1.png";